export default state => state;
